define('views/components/distributor_role/distributor_roles',['require','views/base/collection_view','views/components/distributor_role/distributor_role_list','text!templates/base/collection.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/distributor_role/distributor_role_list');

    var temp = require("text!templates/base/collection.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container distributor-roles-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});
